import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
	Card,
	CardBody,
	Row,
	Col,
	Table,
	Button,
	Pagination,
	PaginationItem,
	PaginationLink,
	Dropdown,
	DropdownMenu,
	DropdownItem,
	UncontrolledDropdown,
	Alert,
	DropdownToggle,
	Nav,
	NavItem,
	NavLink,
	TabContent,
	TabPane, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input
} from "reactstrap";
import { FaCalendar } from "react-icons/fa";
import { FaInfoCircle, FaTimes } from "react-icons/fa";
import classnames from 'classnames';
import { BASE_URL } from "../../../constants";
import axios from "axios";

const leaseStatusMapping = {
	'Listed': 'LISTED',
	'Moving In': 'MOVING_IN',
	'Current': 'CURRENT',
	'Moving Out': 'MOVING_OUT',
	'Current Renewal': 'CURRENT_RENEWAL',
	'Moving Out SD Pending': 'MOVING_OUT_SD_PENDING',
	'SD Returned': 'SD_RETURNED',
	'Moving in Roommate': 'MOVING_IN_ROOMMATE',
	'Moving out Roommate': 'MOVING_OUT_ROOMMATE',
	'Moving out SD Pending Roommate': 'MOVING_OUT_SD_PENDING_ROOMMATE',
	'SD Returned Roommate': 'SD_RETURNED_ROOMMATE'
};

let apiTimeoutId = null;

function PropertyLease() {
	const navigate = useNavigate();
	const [property, setProperty] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [perPage, setPerPage] = useState(10);
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [searchQuery, setSearchQuery] = useState("");
	const [errMsg, setErrMsg] = useState(null);
	const [leaseStatus, setLeaseStatus] = useState('ALL');
	const [selectedProperty, setSelectedProperty] = useState(null);
	const [message, setMessage] = useState("")
	const [inviteDate, setInviteDate] = useState("");
	const [disableDate, setDisableDate] = useState("");
	const [modal, setModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [isFormDisabled, setIsFormDisabled] = useState(false);
	
	const toggleModal = () => setModal(!modal);

	useEffect(() => {
		if (apiTimeoutId) clearTimeout(apiTimeoutId);

		apiTimeoutId = setTimeout(() => {
			fetchData();
		}, 500);
	}, [currentPage, perPage, searchQuery, leaseStatus]);

	const toggleDropdown = () => {
		setDropdownOpen(prevState => !prevState);
	};


	useEffect(() => {
		if (selectedProperty) {
			setMessage(`Dear ${selectedProperty.tenant_first_name} ${selectedProperty.tenant_last_name},
    Welcome to your new home, ${selectedProperty.property_name}. Please complete this move-in inspection as soon as possible to document the condition of the property as received.
    You must download the app and use the provided password to login in the App. The password is provided below.
    For any issues, please reply to this email.
    Thank you!`);

			if (selectedProperty.is_movein_invited == 1) {
				console.log({selectedProperty})
				if (selectedProperty.movein_invite_on) {
					setInviteDate(new Date(selectedProperty.movein_invite_on).toISOString().split('T')[0]);
				}
				if (selectedProperty.movein_disable_on) {
					setDisableDate(new Date(selectedProperty.movein_disable_on).toISOString().split('T')[0]);
				}
			}
		}
	}, [selectedProperty]);


	const fetchData = () => {
		const token = localStorage.getItem('token');
		if (token) {
			const params = new URLSearchParams({
				page_no: currentPage,
				per_page: perPage,
				q: searchQuery,
				status: leaseStatus,
			});
			fetch(`${BASE_URL}/propertylease/list?${params}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						const formattedProperties = data.result.data.map(property => {
							const formattedProperty = { ...property };
							formattedProperty.start_date = new Date(property.start_date).toLocaleDateString('en-US');
							formattedProperty.end_date = new Date(property.end_date).toLocaleDateString('en-US');
							formattedProperty.move_in_date = property.move_in_date ? new Date(property.move_in_date).toLocaleDateString('en-US') : '';
							formattedProperty.move_out_date = property.move_out_date ? new Date(property.move_out_date).toLocaleDateString('en-US') : '';
							return formattedProperty;
						});
						setProperty(formattedProperties);
						setTotalPages(data.result.meta_info.total_pages);
					}
					else {
						console.error("Error: Unable to fetch property data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {
			console.error("Error: Authorization token is missing.");
		}
	};

	const handleAddPropertyLease = () => {
		navigate('/lease/add')
	};

	const handlePageClick = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	const handlePerPageChange = (value) => {
		setPerPage(value);
		setCurrentPage(1);
	};

	const handleDeletePropertyLease = async (id) => {
		console.log(`Delete Renter with ID: ${id}`);

		// Ask for confirmation
		const confirmed = window.confirm("Are you sure you want to delete this Renter Connection?");

		// If user confirms deletion
		if (confirmed) {
			try {
				const token = localStorage.getItem('token');
				if (!token) {
					throw new Error('Authorization token is missing.');
				}

				const response = await axios.delete(`${BASE_URL}/propertylease/delete/${id}`, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				});
				setErrMsg(response.data.message);
				fetchData();

			} catch (error) {
				setErrMsg('Error deleting Renter. Please try again.');
			}
		}
	};

	const handleEditPropertyLease = (id) => {
		navigate(`/lease/edit/${id}`, {
			state: {
				property: property
			}
		});
	};


	const handleInvite = (property) => {
		setSelectedProperty(property);
		setIsFormDisabled(property.movein_status === 'Scheduled' || property.movein_status === 'Submitted');
		toggleModal();
	};

	const handleSendInvite = async () => {
		setLoading(true);
		setErrMsg("");

		try {
			const token = localStorage.getItem('token');
			if (!token) {
				throw new Error('Authorization token is missing.');
			}

			const response = await axios.post(`${BASE_URL}/propertylease/invite-tenant`, {
				"lease_id": selectedProperty?.id,
				"message": message,
				"type": "MOVE_IN",
				"movein_invite_on": inviteDate,
				"movein_disable_on": disableDate
			}, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});
			console.log(response, 'response')
			setErrMsg(response.data.message);
			setMessage("");
			setInviteDate("");
			setDisableDate("");
			toggleModal();

		} catch (error) {
			setErrMsg(error.message || "Error sending invite. Please try again.");
		} finally {
			setLoading(false);
		}
	};



	return (
		<div className="content">
			{errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

			<Row>
				<Col xs="6">
					<h4 className="mt-0">Renter Connection</h4>
				</Col>

				<Col xs="6" className="text-end">
					<Button color="primary" onClick={handleAddPropertyLease}>Add Renter Connection</Button>
				</Col>
			</Row>

			
			<Card>
				<CardBody>
					<Row className="my-3">
						<Col>
							{/* 
							{Object.entries(leaseStatusMapping).map(([label, value]) => (
								<DropdownItem key={label} onClick={() => { handleStatusChange(value); }}>
									{label}
								</DropdownItem>
							))}
							*/}
						</Col>
						<Col xs="12" className="text-end">
							<Input
								type="text"
								placeholder="Search..."
								value={searchQuery}
								onChange={e => setSearchQuery(e.target.value)}
								style={{ display: 'inline-block', width: 'auto', marginRight: '10px' }}
							/>
						</Col>
					</Row>
					<Table >
						<thead>
							<tr>
								<th>#</th>
								<th>Property</th>
								<th>Renter</th>
								<th>Renter Move In</th>
								<th>Status</th>
								<th>Move In</th>
								<th>Move Out</th>
								<th>Actions</th>

							</tr>
						</thead>
						<tbody>
							{property.length > 0 ? property.map((property, index) => (
								<tr key={index}>
									<td>{(currentPage - 1) * perPage + index + 1}</td>
									<td>{property.property_name}</td>
									<td>{property.tenant_first_name} {property.tenant_last_name}</td>
									<td>
										<a href="#" className="invite-link" onClick={() => handleInvite(property)}>{property.movein_status}</a>
									</td>
									<td>{Object.keys(leaseStatusMapping).find(key => leaseStatusMapping[key] === property.status)}</td>
									<td>{property.move_in_date}</td>
									<td>{property.move_out_date}</td>
									<td>
										<UncontrolledDropdown>
											<DropdownToggle
												caret
												color="primary"
											>
												Action
											</DropdownToggle>
											<DropdownMenu primary>
												<DropdownItem onClick={() => handleEditPropertyLease(property.id)}>
													Edit
												</DropdownItem>
												<DropdownItem onClick={() => handleDeletePropertyLease(property.id)}>
													Delete
												</DropdownItem>
											</DropdownMenu>
										</UncontrolledDropdown>
									</td>

								</tr>
							)) : (
								<tr>
									<td colSpan="12" className="text-center">No data available</td>
								</tr>
							)}
						</tbody>
					</Table>
				</CardBody>
				<Row>
					<Col xs="4">
						<div style={{ marginLeft: '25px' }}>
							<Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
								<DropdownToggle caret color="primary">
									Per Page: {perPage}
								</DropdownToggle>
								<DropdownMenu>
									<DropdownItem onClick={() => handlePerPageChange(5)}>5</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(10)}>10</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(20)}>20</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(50)}>50</DropdownItem>
								</DropdownMenu>
							</Dropdown>
						</div>
					</Col>
					<Col xs="8" className="text-right">
						<div style={{ display: 'flex', justifyContent: 'end', alignItems: 'end', marginRight: '25px', marginTop: '10px' }}>
							<Pagination aria-label="Page navigation example">
								<PaginationItem disabled={currentPage === 1}>
									<PaginationLink

										previous
										onClick={() => handlePageClick(currentPage - 1)}
									/>
								</PaginationItem>

								{currentPage > 3 && (
									<>
										<PaginationItem>
											<PaginationLink onClick={() => handlePageClick(1)}>
												1
											</PaginationLink>
										</PaginationItem>
										<PaginationItem disabled>
											<PaginationLink>...</PaginationLink>
										</PaginationItem>
									</>
								)}

								{Array.from({ length: 5 }, (_, i) => {
									const page = currentPage <= 3 ? i + 1 : currentPage - 2 + i;
									return (
										page <= totalPages && (
											<PaginationItem key={page} active={currentPage === page}>
												<PaginationLink

													onClick={() => handlePageClick(page)}
												>
													{page}
												</PaginationLink>
											</PaginationItem>
										)
									);
								})}

								{currentPage < totalPages - 2 && (
									<>
										<PaginationItem disabled>
											<PaginationLink>...</PaginationLink>
										</PaginationItem>
										<PaginationItem>
											<PaginationLink onClick={() => handlePageClick(totalPages)}>
												{totalPages}
											</PaginationLink>
										</PaginationItem>
									</>
								)}

								<PaginationItem disabled={currentPage === totalPages}>
									<PaginationLink

										next
										onClick={() => handlePageClick(currentPage + 1)}
									/>
								</PaginationItem>
							</Pagination>
						</div>
					</Col>
				</Row>
			</Card>



			<Modal isOpen={modal} toggle={toggleModal} centered size="md">
				<ModalHeader toggle={toggleModal} style={{ display: 'flex', justifyContent: 'space-between' }}
					close={
						<button className="close" onClick={toggleModal} style={{ outline: 'none', border: 'none', background: 'transparent' }}>
							<FaTimes size={20} />
						</button>
					}>
					Invite Renter
				</ModalHeader>

				<ModalBody>

					<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
						<Label for="message">Message*</Label>
						<Input
							type="textarea"
							name="message"
							id="message"
							value={message}
							onChange={(e) => setMessage(e.target.value)}
							disabled={isFormDisabled}
							style={{ height: '250px' }} />
					</FormGroup>

					<p style={{ paddingLeft: '10px', paddingRight: '10px' }}>
						<FaInfoCircle />
						Anything typed in the white box with the name of Message will be sent to the renter.
						The text will be followed automatically with all information needed by
						the renter to do the renter move-in inspection including:
						<strong> App Download Links, Secure Login Information, Property Name, </strong> and <strong> Renter Start Date</strong>
					</p>

					<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
						<FaCalendar />

						<Label style={{ paddingLeft: '5px' }} for="inviteDate">Send Invitation On*</Label>
						<Input
							type="date"
							name="inviteDate"
							id="inviteDate"
							value={inviteDate}
							onChange={(e) => setInviteDate(e.target.value)}
							disabled={isFormDisabled}
						/>
					</FormGroup>

					<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
						<FaCalendar />
						<Label style={{ paddingLeft: '5px' }} for="disableDate">Disable Access On*</Label>
						<Input
							type="date"
							name="disableDate"
							id="disableDate"
							value={disableDate}
							onChange={(e) => setDisableDate(e.target.value)}
							disabled={isFormDisabled}
						/>
					</FormGroup>

				</ModalBody>
				<ModalFooter>
					<Button color="primary" onClick={handleSendInvite} disabled={loading || isFormDisabled}>
						{loading ? 'Sending...' : 'Send Invite'}
					</Button>{' '}
					<Button color="secondary" onClick={toggleModal} disabled={loading}>
						Cancel
					</Button>
				</ModalFooter>
			</Modal>

		</div>
	);
}

export default PropertyLease;
